import { render, staticRenderFns } from "./LiteratureNew.vue?vue&type=template&id=0cb8eeb0&scoped=true&"
import script from "./LiteratureNew.vue?vue&type=script&lang=js&"
export * from "./LiteratureNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb8eeb0",
  null
  
)

export default component.exports